import React from 'react';
import './sec1-p3.css'
import pic20 from '../assets/pic20.png'
import pic21 from '../assets/pic21.png'
import pic22 from '../assets/pic22.png'
import pic23 from '../assets/pic23.png'
import { Link } from 'react-router-dom';

const Sec1p3 = () => {
    return ( 
        <section className='sec1-p3 '>
            <figure className='container-sec1-p3'>
                <figure className='text-cont-sec1-p3'>
                    <Link to="/Propertieslist" class='linksss'>
                        <figure className='container-back'>
                            <img src={pic20} alt='back' ></img>
                            <h3 className='backk'>Back</h3>
                        </figure>
                    </Link>
                        <figure className='img-big-cont-sec1-p3'>
                            <figure className='container-img1-p3'>
                                <img src={pic21} alt='pic' className='imgss-sec1-p3'></img>
                            </figure>

                            <figure className='right-box-sec1-p3'>
                                <figure className='main-img-container-p3'>
                                    <img src={pic22} alt='pic' className='imgss-sec1-p3' ></img>
                                </figure>
                                <figure className='main-img-container-p3'>
                                    <img src={pic23} alt='pic' className='imgss-sec1-p3'>
                                       
                                    </img>
                                     <h2 className='pluss-sec1-p3'>12+</h2>
                                </figure>
                            </figure>


                        </figure>
                </figure>
            </figure>
        </section>
     );
}
 
export default Sec1p3;